import React, { ReactElement } from 'react';

function CardSeperator(): ReactElement {
    return (
        <div className="px-3.5">
            <hr className="border-t-ce-gray-100 h-px" />
        </div>
    );
}

export default CardSeperator;
